<template lang="pug">
	.app
		nav-bar
		vue-page-transition(name="fade")
			router-view
		footer-bar
</template>

<script>
export default {
	computed: {
		locale() {
			return this.$store.state.general.locale
		}
	},
	mounted() {
		if (this.locale) {
			this.$root.$i18n.locale = this.locale
		}
	}
}
</script>
